/*
 * @Author: 李明明
 * @Date: 2022-07-29 14:10:44
 * @LastEditTime: 2024-08-30 13:43:57
 * @LastEditors: 李明明
 * @Description:
 * @FilePath: /ykt-micro-main/src/utils/axios.js
 * 代码版权方：'政府采购信息网'
 */
import axios from "axios";
import qs from "qs";
import Store from "../store";
import * as loginFuc from "@/utils/sso-login";
import { ElMessage } from "element-plus";
axios.defaults.baseURL = process.env.VUE_APP_BASE_URL;
//post请求头
axios.defaults.headers.post["Content-Type"] =
  "application/x-www-form-urlencoded;charset=UTF-8";

// 表示跨域请求时是否需要使用凭证 允许跨域携带cookie信息
axios.defaults.withCredentials = false;

// 允许跨域
axios.defaults.headers.post["Access-Control-Allow-Origin-Type"] = "*";

//设置超时
axios.defaults.timeout = 15000;

const request = axios.create({
  baseURL: process.env.VUE_APP_BASE_URL,
  timeout: 8000,
  headers: {
    "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
    "Access-Control-Allow-Origin-Type": "*",
  },
  withCredentials: false,
});
axios.interceptors.request.use(
  (config) => {
    const userInfo = Store.state.userInfo;
    config.headers["terminal"] = 1;
    config.headers.Authorization = userInfo.ssoToken;
    if (
      config.url != process.env.VUE_APP_FROM_A_URL &&
      config.url != "/ykt_java/verifyToken"
    ) {
      const configData = {
        pcToken: userInfo.examToken,
        userId: userInfo.userid,
        source: 4,
      };
      config.data = qs.stringify(configData) + "&" + config.data;
    }

    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

axios.interceptors.response.use(
  (response) => {
    if (
      response.config.url == process.env.VUE_APP_FROM_A_URL ||
      response.config.url == "/ykt_java/verifyToken"
    ) {
      return Promise.resolve(response);
    } else {
      if (response.status == 200) {
        const code = response.data.resCode;
        // 检查是否需要跳过错误提示
        const skipErrorToast = response.config.skipErrorToast;
        switch (code) {
          case 200:
            return Promise.resolve(response);
            break;
          case 201:
            return Promise.reject(response.data);

            break;
          case 300:
            if (response.config.url != "/study/verifyStudyFaceResult" && !skipErrorToast) {
              ElMessage.error(response.data.resMessage);
            }
            break;
          case 401:
            if (!skipErrorToast) {
              ElMessage.error(response.data.resMessage);
              setTimeout(() => {
                loginFuc.login();
              }, 2000);
            } else {
              // 当 skipErrorToast 为 true 时，reject 以便在 catch 中处理
              return Promise.reject(response.data);
            }
            break;
          case 405:
            if (!skipErrorToast) {
              ElMessage.error(response.data.resMessage);
              loginFuc.login();
            }
            break;
          case 406:
            if (!skipErrorToast) {
              ElMessage.error(response.data.resMessage);
              loginFuc.login();
            }
            break;
          case 407:
            if (!skipErrorToast) {
              ElMessage.error(response.data.resMessage);
              loginFuc.login();
            }
            break;
          case 410:
            if (!skipErrorToast) {
              ElMessage.error(response.data.resMessage);
              loginFuc.login();
            }
            break;
          case 411:
            if (!skipErrorToast) {
              ElMessage.error(response.data.resMessage);
              loginFuc.login();
            }
            break;
          case 999: // 不能多端学习考试
            return Promise.resolve(response);
          case 2001:
            if (!skipErrorToast) {
              ElMessage.error(response.data.resMessage);
              window.location.href = "/#/";
            }
            break;
          case 2002:
            // ElMessage.error(response.data.resMessage);
            // window.location.href = "/#/";
            break;
          // 学习中人脸识别失败
          case 2003:
            return Promise.resolve(response);
            break;
          default:
            if (!skipErrorToast) {
              ElMessage.error(response.data.resMessage);
            }
            break;
        }
      } else {
        return Promise.reject(response);
      }
    }
  },
  (error) => {
    console.log(error);
  }
);
export default {
  /**
   * @param {String} url
   * @param {Object} data
   * @returns Promise
   */
  post(url, data, config = {}) {
    return new Promise((resolve, reject) => {
      axios({
        method: "post",
        url,
        data: qs.stringify(data),
        ...config,
      })
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },

  get(url, data) {
    return new Promise((resolve, reject) => {
      axios({
        method: "get",
        url,
        params: data,
      })
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  uploadFiles(url, data) {
    const userInfo = Store.state.userInfo;
    return new Promise((resolve) => {
      const userInfo = Store.state.userInfo;
      let headers = {
        "Content-Type": "multipart/form-data",
        terminal: 1,
        Authorization: userInfo.ssoToken,
      };
      let formData = new FormData();
      formData.append("pcToken", userInfo.examToken);
      formData.append("userId", userInfo.userid);
      formData.append("source", 4);
      Object.keys(data).forEach((key) => {
        if (key == "file") {
          formData.append(key, data[key], "1.png");
        } else {
          formData.append(key, data[key]);
        }
      });

      request
        .post(url, formData, { headers })
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
};
